<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
import ContentsTitle from './ContentsTitle.vue';

const props = defineProps({
  isMobile: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <VRow class="full-height over-hidden">
    <!-- 왼쪽 컬럼: 2026년은 고민과 방향이 중요해지는 한 해! -->
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-first guide-left-col">
      <VCard class="personality-card full-height right guide-left-card">
        <!-- 타이틀 -->
        <ContentsTitle
          text="📖 2026년은 고민과 방향이 중요해지는 한 해!"
          :isMobile="isMobile"
        />
        <div class="detailed-analysis-box yearly-fortune-wrapper yearly-fortune__guide-01">
          <div class="title-box">
            <div class="title">
              2026년 병오년,<br />
              고민에 머물기보다 '움직임'의 방향이 중요해지는 해입니다.
            </div>
            <div class="subtitle-group">
              <div class="subtitle">
                2026년은 정적이고 차분하기보다는<br />
                무언가를 해보고 싶어지는 흐름이 자연스럽게 살아나는 해입니다.
              </div>
              <div class="subtitle">
                병오년은 열정과 추진의 기운이 겹치는 해라,<br />
                생각이 머릿속에만 머무르기보다<br />
                실제 '움직임'으로 이어지기 쉬운 해이기 때문입니다.
              </div>
              <div class="subtitle">
                열정의 에너지가 가득한 병오년<br />
                한 해의 큰 흐름을 살펴보며 나에게 맞는 희망의 방향을 그려봅니다.
              </div>
            </div>
          </div>
          <section class="yearly-fortune-content-box guide-content-box">
            <div class="speech-bubble__container yearly-fortune">
              <div class="speech-bubble__row speech-bubble__row--left">
                <div class="speech-bubble">
                  "이제는 움직여야 하지 않을까?"
                  <svg
                    class="speech-bubble__tail"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="11"
                    viewBox="0 0 16 11"
                    fill="none"
                    shape-rendering="geometricPrecision"
                  >
                    <path d="M0 0H16L9.2 9.2Q8 11 6.8 9.2L0 0Z" fill="#BE3331" />
                  </svg>
                </div>
              </div>
              <div class="speech-bubble__row speech-bubble__row--right">
                <div class="speech-bubble">
                  "계속 미뤄온 걸 정리해볼때가 된것 같아"
                  <svg
                    class="speech-bubble__tail"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="11"
                    viewBox="0 0 16 11"
                    fill="none"
                    shape-rendering="geometricPrecision"
                  >
                    <path
                      d="M0 0H16L9.2 9.2Q8 11 6.8 9.2L0 0Z"
                      fill="#BE3331"
                      fill-opacity="0.15"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div class="analysis-img-box">
              <div class="analysis-img-box__img--yearly-fortune-horse"></div>
            </div>
            <div class="guide-content-caption">많은 생각이 평소보다 자주 떠오를 수 있습니다.</div>
          </section>
        </div>
      </VCard>
    </VCol>

    <!-- 오른쪽 컬럼: 전체 너비 섹션들 -->
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-second">
      <VCard class="personality-card full-height">
        <div class="yearly-guide" :class="{ mobile: isMobile }">
          <!-- 병오년(丙午年)은 ‘움직이게 만드는 에너지가 많은 해’입니다. -->
          <section class="yearly-guide__section">
            <div class="yearly-guide__top" :class="{ mobile: isMobile }">
              <div class="yearly-guide__title">
                <span class="yearly-guide__title-icon yearly-guide__title-icon--triangle">🐴</span>
                <span class="box-title__txt">
                  병오년(丙午年)은&nbsp;
                  <span class="nowrap">'움직이게 만드는 에너지가 많은 해'입니다.</span>
                </span>
              </div>

              <div class="yearly-guide__crossroads-img-box gray">
                <div class="yearly-guide__crossroads-txt">
                  병오년의 에너지는&nbsp;<br />
                  <span class="point"> ‘앞으로 나아가려는 힘’</span>으로
                  <span>해석될 수 있습니다.</span>
                </div>
                <div class="guide-horse-crossroads-img"></div>
                <div class="yearly-guide__crossroads-txt">
                  <span>병오(丙午)년은&nbsp;</span><br />
                  <span>앞으로 나아가려는 힘이 커지는 만큼,</span><br />
                  <span>
                    무언가를
                    <span class="point">'정리하거나, 선택하거나, 시작하게 만드는'</span>
                    기운이 강한 해입니다.
                  </span>
                </div>
              </div>
            </div>

            <div class="box-body">
              <span class="yearly-guide__explain-context">
                <span>의욕이 앞서기 쉬운 해인 만큼&nbsp;</span>
                <span class="point">방향이 정리되지 않으면&nbsp;</span>
                <span>
                  <span class="point">괜히 힘만 쓰고 지치는 느낌</span>이 들 수도 있습니다.
                </span>
              </span>
            </div>
            <div class="box-body">
              <span class="yearly-guide__explain-context">
                <span>그래서 2026년은 ‘빨리 달려가는 것’보다&nbsp;</span>
                <span>
                  <span class="point">‘어디로 가느냐’</span>를 먼저 정해야 편해지는 해입니다.
                </span>
                <br />
                <span>
                  같은 힘을 써도,
                  <span class="point">
                    방향에 따라 누군가는 도약을 만들고 누군가는 소모만 느끼기 쉬운 해
                  </span>
                  이기도 합니다.
                </span>
              </span>
            </div>
          </section>
          <div class="yearly-guide__line-box"></div>

          <!-- 신년운세는 이렇게 읽어주세요. -->
          <section class="yearly-guide__section">
            <div class="yearly-guide__top" :class="{ mobile: isMobile }">
              <div class="yearly-guide__title">
                <span class="yearly-guide__title-icon yearly-guide__title-icon--triangle">🌈</span>
                <span class="box-title__txt">신년운세는 이렇게 읽어주세요.</span>
              </div>
              <div class="yearly-guide__crossroads-img-box gray-small">
                <div class="yearly-0106-img"></div>
                <div class="yearly-guide__crossroads-txt">
                  낭만만세력의 신년운세는<br />
                  '올해 얼마나 잘 될까요?'를 묻기보다,
                </div>
                <div class="yearly-guide__crossroads-txt">
                  <span class="point">
                    <span class="nowrap">이 많은 에너지를&nbsp;</span>
                    <span class="nowrap">어디에 쓰는 게 나에게 맞는지를</span>
                  </span>
                  <br />
                  <span> 함께 정리해보는 데 초점을 두고 있습니다. </span>
                </div>
              </div>
            </div>
            <div class="box-body" style="align-self: flex-start">
              <span class="yearly-guide__explain-context">
                특히 올해는&nbsp;
                <span class="point">힘을 쓸 곳과 힘을 덜어낼 곳을&nbsp;</span>
                <span class="nowrap"><span class="point">잘 구분하고 선별</span>할수록&nbsp;</span>
                훨씬 유리하고, 더 편안해질 수 있는 흐름입니다.
              </span>
            </div>
            <div class="box-body" style="align-self: flex-start">
              <span class="yearly-guide__explain-context">
                무엇을 더 해야 할지를 고민하기보다,
                <span class="nowrap">
                  <span class="point">무엇을 줄이고 어떤 선택을 남길지&nbsp;</span>
                </span>
                <span class="nowrap"><span class="point">정리</span>해 나갈수록&nbsp;</span>
                한 해의 방향은 훨씬 또렷해질 수 있습니다.
              </span>
            </div>
          </section>

          <!-- 같은 병오년, 모두에게 똑같지는 않습니다. -->
          <section class="yearly-guide__section">
            <div class="yearly-guide__top" :class="{ mobile: isMobile }">
              <div class="yearly-guide__title">
                <span class="yearly-guide__title-icon yearly-guide__title-icon--triangle">❤</span>
                <span class="box-title__txt"
                  ><span class="nowrap">같은 병오년,&nbsp;</span>
                  <span class="nowrap">모두에게 똑같지는 않습니다.</span></span
                >
              </div>
              <div class="yearly-guide__crossroads-img-box gray-small">
                <div class="yearly-guide__crossroads-txt">
                  <span class="nowrap">같은 병오년이라도&nbsp;</span>
                  <span class="nowrap">누군가에게는 도약의 해가 되고,</span>
                  <br />
                  누군가에게는 방향을 다시 잡는 해가 됩니다.
                </div>
                <div class="yearly-guide__crossroads-txt">
                  <span class="nowrap">각자가 가진 성향과 흐름에 따라,</span><br />
                  <span class="nowrap">
                    이 <span class="point">'움직임의 에너지'</span>가&nbsp;
                  </span>
                  작용하는 방식이 다르기 때문입니다.
                </div>
              </div>
            </div>
          </section>

          <section class="guide-box full-width-bottom">
            <div class="yearly-guide__quote">
              <div class="icon-quote"></div>
              <div class="yearly-guide__quote-content">
                <div>어떤 선택이 <span class="yearly-guide__quote-bold">힘</span>이 되고,</div>
                <div>
                  어떤 선택이 <span class="yearly-guide__quote-underline">소모</span>가 되는지를
                  살펴보며
                </div>
                <div>
                  2026년을
                  <span class="yearly-guide__quote-red"> '힘이 되는 선택의 시간' </span>으로
                </div>
                <div>만들어 가시길 기원드립니다.</div>
              </div>
            </div>
            <div class="yearly-guide__footer">
              <div class="yearly-guide__footer-character"></div>
              <div class="yearly-guide__footer-content">
                <div class="yearly-guide__footer-title">낭만만세력은</div>
                <div class="yearly-guide__footer-text">
                  <span class="nowrap">삶의 방향을 조율해가는&nbsp;</span>
                  <span class="nowrap">따뜻한 이정표가 될 수 있도록&nbsp;</span>
                  <span class="nowrap">지속적으로 연구하고,&nbsp;</span>
                  <span class="nowrap">더 나은 서비스로 발전시켜 나가겠습니다.</span>
                </div>
              </div>
            </div>
          </section>
        </div>
      </VCard>
    </VCol>
  </VRow>
</template>

<style scoped lang="scss">
@import '@/assets/nangman_style/_analysis_main_color.scss';

.nowrap {
  white-space: nowrap;
}

.full-width-top,
.full-width-bottom {
  width: 100%;
}

.two-column-middle {
  margin: 0;
  width: 100%;
}

.guide-horse-character-img {
  width: 200px;
  height: 200px;
  aspect-ratio: 1/1;
  background: url('@manseImages/yearly-fortune/img_year_01.png') center center no-repeat;
  background-size: contain;
  margin: 0 auto;
  position: relative;

  .thought-bubbles {
    position: absolute;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
    z-index: 1;

    .thought-bubble {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-weight: 700;

      &.pink-bubble {
        background: #ffe5e5;
        color: var(--Gray-800, #333);
      }

      &.orange-bubble {
        background: #ffe5cc;
        color: var(--orange-300-main, #eb4c10);
      }
    }
  }
}

.guide-left-col {
  overflow: hidden !important;
  align-self: stretch !important;
}

.guide-left-card {
  overflow-y: auto !important;
  overflow-x: hidden !important;
  height: fit-content !important;
  max-height: calc(100vh - 60px) !important;
}

.yearly-fortune__guide-01 {
  gap: 30px;
}

.guide-content-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: var(--Gray-200, #f8f8f8);
  border-top: 1px solid var(--Gray-300, #ebebeb);
  border-bottom: 1px solid var(--Gray-300, #ebebeb);
  padding: 30px 12px;

  @media (max-width: 768px) {
    margin: 0 -16px;
    width: calc(100% + 32px);
  }
}

.guide-content-caption {
  color: var(--Gray-800, #333);
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
}

.subtitle-group {
  display: flex;
  flex-direction: column;
  gap: 8px;

  .subtitle {
    color: var(--Gray-800, #333);
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 160% */
  }
}

.speech-bubble__container.yearly-fortune {
  width: 100%;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;

  @media (max-width: 768px) {
    padding-left: 0;
  }

  .speech-bubble__row {
    width: 100%;
    display: flex;
    height: 56px;

    .speech-bubble {
      position: relative;
      width: fit-content;
      max-width: 100%;
      height: 45px;
      padding: 0 16px;
      border-radius: 10px;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      overflow: visible;
    }

    .speech-bubble__tail {
      position: absolute;
      bottom: -11px;
      pointer-events: none;
      display: block;
    }

    &--left {
      justify-content: flex-start;

      .speech-bubble {
        min-width: 217px;
        background: #be3331;
        color: var(--gray-100-white, #fff);
        font-family: Pretendard;
        font-size: 15px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px; /* 160% */
      }

      .speech-bubble__tail {
        left: 30px;
      }
    }

    &--right {
      justify-content: flex-end;

      .speech-bubble {
        min-width: 272px;
        background: rgba(190, 51, 49, 0.15);
        color: var(--Gray-800, #333);
        font-family: Pretendard;
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 160% */
      }

      .speech-bubble__tail {
        right: 30px;
      }
    }
  }
}

.mt-30 {
  margin-top: 30px;
}

.yearly-guide__line-box {
  width: 100%;
  border-bottom: 1px solid var(--Gray-300, #ebebeb);
}

.yearly-guide__explain-multiple {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
}
.yearly-guide__explain-context {
  width: 100%;
  color: var(--Gray-800, #333);
  text-align: left;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 160% */
  .point {
    color: #be3331;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
  }

  @media (max-width: 768px) {
    max-width: 340px;
    display: flex;
    flex-wrap: wrap;
  }
}

// 오른쪽 컬럼 영역 스타일 (이 페이지 전용 - BEM 방법론 적용)
// Block: yearly-guide
.yearly-guide {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 24px;
  padding-bottom: 130px; // 하단 여백 추가
  gap: 30px;

  &.mobile {
    padding: 16px;
    padding-bottom: 24px;
  }

  &__section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    align-self: stretch;
  }

  &__top {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
    align-self: stretch;
  }

  // Element: title
  &__title {
    color: var(--Gray-800, #333);
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 160% */
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    // Element: title-icon
    &-icon {
      font-size: 20px;
      font-weight: 700;
      flex-shrink: 0;

      // Modifier: triangle
      &--triangle {
        margin-right: 4px;
        color: var(--orange-300-main, #eb4c10);
      }

      // Modifier: checkmark
      &--checkmark {
        background: linear-gradient(180deg, #ff6b6b 0%, #ff8e8e 50%, #4ecdc4 50%, #44a08d 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      // Modifier: star
      &--star {
        color: #4caf50;
      }

      // Modifier: heart
      &--heart {
        color: #ff6b6b;
      }
    }
  }

  // Element: highlight (box-body 내부에서 사용)
  &__highlight {
    color: $analysis-yearly-fortune;
    font-weight: 500;
  }

  &__crossroads-img-box {
    display: flex;
    padding: 40px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    &.none-padding {
      padding: 0;
    }
    &.gray {
      border-radius: 12px;
      background: var(--Gray-200, #f8f8f8);
    }
    &.gray-small {
      padding: 20px 16px;
      border-top: 1px solid var(--Gray-300, #ebebeb);
      border-bottom: 1px solid var(--Gray-300, #ebebeb);
      background: var(--Gray-200, #f8f8f8);
    }
  }
  &__crossroads-txt {
    color: var(--Gray-800, #333);
    text-align: center;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    .point {
      font-weight: 700;
    }
    @media (max-width: 768px) {
      max-width: 270px;
      // display: flex;
      // flex-wrap: wrap;
      // align-items: center;
      // justify-content: center;
    }
  }
  // Element: quote
  &__quote {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 0;
    position: relative;
    width: 100%;

    .icon-quote {
      width: 28px;
      height: 22px;
      background: url('@manseImages/icon_quotes.svg') center center no-repeat;
      background-size: contain;
      flex-shrink: 0;
    }

    // Element: quote-content
    &-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: var(--Gray-800, #333);
      text-align: center;
      font-family: Pretendard;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 28px; /* 175% */
      // 밑줄만 (볼드 없음)
      .yearly-guide__quote-underline {
        position: relative;
        &::before {
          content: '';
          display: block;
          width: 110%;
          height: 8px;
          background: rgba(51, 51, 51, 0.1);
          position: absolute;
          left: -5%;
          bottom: 0;
        }
      }
      // 밑줄 + 볼드
      .yearly-guide__quote-bold {
        position: relative;
        color: var(--Gray-800, #333);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 28px;
        // &::before {
        //   content: '';
        //   display: block;
        //   width: 110%;
        //   height: 8px;
        //   background: rgba(51, 51, 51, 0.1);
        //   position: absolute;
        //   left: -5%;
        //   bottom: 0;
        // }
      }
      .yearly-guide__quote-red {
        position: relative;
        color: #be3331;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 28px;
        &::before {
          content: '';
          display: block;
          width: 106%;
          height: 8px;
          background: rgba(190, 51, 49, 0.2);
          position: absolute;
          left: -3%;
          bottom: -2px;
        }
      }
    }
  }

  // Element: footer
  &__footer {
    display: flex;
    width: calc(100% + 48px); // 좌우 padding(24px * 2)만큼 너비 확장
    margin-left: -24px; // 상위 padding 상쇄
    margin-right: -24px; // 상위 padding 상쇄
    padding: 20px 32px;
    align-items: center;
    gap: 20px;
    border-radius: 12px;
    background: rgba(190, 51, 49, 0.05);

    @media (max-width: 768px) {
      margin: 0;
      padding: 20px 16px;
      width: 100%;
      flex-direction: column;
      gap: 20px;
      text-align: center;
    }

    // Element: footer-character
    &-character {
      width: clamp(80px, 9vw, 140px);
      height: clamp(80px, 9vw, 140px);
      min-width: 80px;
      border-radius: 50%;
      background: url('@manseImages/yearly-fortune/img_year_guide_0104.png') center center no-repeat;
      background-size: cover;
      flex-shrink: 0;

      @media (max-width: 768px) {
        width: 100px;
        height: 100px;
      }
    }

    // Element: footer-content
    &-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    // Element: footer-title
    &-title {
      color: #be3331;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
    }

    // Element: footer-text
    &-text {
      max-width: 300px;
      display: flex;
      flex-wrap: wrap;
      color: var(--Gray-800, #333);
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;

      @media (max-width: 768px) {
        justify-content: center;
        max-width: 100%;
      }
    }
  }
}

// box-body 내부에서 yearly-guide__highlight 사용
.box-body {
  width: 100%;
  .yearly-guide__highlight {
    color: $analysis-yearly-fortune;
    font-weight: 500;
  }
}

// 이미지 스타일 (기존 guide- 접두사 유지)
.guide-horse-crossroads-img {
  margin: 0 16px;
  width: 262px;
  height: 153px;
  background: url('@manseImages/yearly-fortune/img_year_guide_0102.png') center center no-repeat;
  background-size: 262px 153px;
  margin: 0 auto;
  flex-shrink: 0;
}

.guide-corkboard-img {
  width: 100%;
  height: 200px;
  aspect-ratio: 4/3;
  background: url('@manseImages/yearly-fortune/img_year_01.png') center center no-repeat;
  background-size: contain;
  margin: 0 auto;
}
.yearly-0103-img {
  width: 282px;
  height: 187px;
  aspect-ratio: 282/187;
  background: url('@manseImages/yearly-fortune/img_year_guide_0103.png') center center no-repeat;
  background-size: 282px 187px;
  margin: 0 auto;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 221px;
    height: 147px;
    aspect-ratio: 221/147;
    background-size: 221px 147px;
  }
}
.yearly-0106-img {
  width: 134px;
  height: 134px;
  background: url('@manseImages/yearly-fortune/img_year_guide_0106.png') center center no-repeat;
  background-size: 134px 134px;
  margin: 0 auto;
  flex-shrink: 0;
}
.yearly-0105-img {
  width: 160px;
  height: 140px;
  aspect-ratio: 160/140;
  background: url('@manseImages/yearly-fortune/img_year_guide_0105.png') center center no-repeat;
  background-size: 160px 140px;
  margin: 0 auto;
  flex-shrink: 0;

  @media (max-width: 768px) {
    aspect-ratio: 160/140;
  }
}
</style>
